import { render } from "./MeetingDetail.vue?vue&type=template&id=2d349e43&scoped=true"
import script from "./MeetingDetail.vue?vue&type=script&lang=js"
export * from "./MeetingDetail.vue?vue&type=script&lang=js"

import "./MeetingDetail.vue?vue&type=style&index=0&id=2d349e43&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d349e43"]])

export default __exports__